import {ActionIcon, Box, Card, Group, Stack, Text, Tooltip} from "@mantine/core";
import {IconEdit, IconTrash} from "@tabler/icons-react";
import type {LocalLibraryEntry} from "@/app/storage";

export function LibraryCharacterTile(props: {
  entry: LocalLibraryEntry;
  onEdit: (entry: LocalLibraryEntry) => void;
  onDelete: (uri: string) => void;
}) {
  const {entry, onEdit, onDelete} = props;
  return (
    <Card
      key={entry.uri}
      withBorder
      padding="sm"
      radius="md"
      shadow="sm"
      className="glass-card"
    >
      <Stack align="center" gap={4} style={{position: "relative"}}>
        <Box style={{position: "absolute", top: -4, right: -4}}>
          <Group gap={2}>
            <ActionIcon variant="subtle" size="xs" onClick={() => onEdit(entry)}>
              <IconEdit size={12} />
            </ActionIcon>
            <ActionIcon
              variant="subtle"
              color="red"
              size="xs"
              onClick={() => onDelete(entry.uri)}
            >
              <IconTrash size={12} />
            </ActionIcon>
          </Group>
        </Box>
        <Text
          style={{fontSize: "2.5rem", lineHeight: 1, fontWeight: 700}}
          lang={entry.languageCode}
        >
          {entry.content.expression}
        </Text>
        <Tooltip
          label={entry.content.readings?.map(r => r.value).join(", ") || "No readings"}
        >
          <Text size="xs" c="dimmed" truncate style={{maxWidth: "100%"}}>
            {entry.content.readings?.[0]?.value || ""}
          </Text>
        </Tooltip>
        <Text size="sm" fw={500} ta="center" lineClamp={1}>
          {entry.content.meaning}
        </Text>
      </Stack>
    </Card>
  );
}
